import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  DisablePointerEvents,
  DropZoneDisabled,
  DropZoneEnabled,
  EnablePointerEvents,
  FileToUploadChanged,
  NotificationEmailChanged,
} from '../actions/ticket-resolve.actions';
import { TicketResolveState } from '../models/tickets.models';

const initialState: TicketResolveState = {
  dropZone: false,
  pointerEvents: false,
  fileName: '',
  file: {},
  notificationEmail: '',
};

export const TicketResolveReducer = createReducer(
  initialState,
  on(DropZoneEnabled, (state) => ({
    ...state,
    dropZone: true,
  })),
  on(DropZoneDisabled, (state) => ({
    ...state,
    dropZone: false,
    pointerEvents: false,
  })),
  on(EnablePointerEvents, (state) => ({
    ...state,
    pointerEvents: true,
  })),
  on(DisablePointerEvents, (state) => ({
    ...state,
    pointerEvents: false,
  })),
  on(FileToUploadChanged, (state, { file }) => ({
    ...state,
    file,
    fileName: file.name ?? '',
  })),
  on(NotificationEmailChanged, (state, { notificationEmail }) => ({
    ...state,
    notificationEmail,
  })),
  on(ActiveComponentChanged, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
